import { createReplaceVariable } from '../utils';

/**
 * TODO: Make keys all caps
 */
const API_KEYS = {
    api_url: createReplaceVariable('https://api-stage.vouchedfor.co.uk') + '/v2/account',
    elevation_url: createReplaceVariable('https://elevation-stage.vouchedfor.co.uk') +'/account',
    public_api_url: createReplaceVariable('https://api-stage.vouchedfor.co.uk') + '/v2/public',
    accounts_url: createReplaceVariable('https://accounts-stage.vouchedfor.co.uk'),
    consumer_url: createReplaceVariable('https://consumer-next-stage.vouchedfor.co.uk'),
    login_url: createReplaceVariable('https://api-stage.vouchedfor.co.uk') + '/v2/account/auth/login',
    cdn: createReplaceVariable('https://cdn.vouchedfor.co.uk'),
    professional: createReplaceVariable('https://professional-stage.vouchedfor.co.uk') + '/v2',
    google_analytics_key: createReplaceVariable('replaceme'),
    mopinion_key: createReplaceVariable('ejdbsncszfd1ohrh870i6yz0134yqcsnmuk'),
    linkedin_pixel_key: createReplaceVariable('dummy-linked-in-key'),
    downgrade_form_url: createReplaceVariable('remove_from_code'),
    survey_api_url: createReplaceVariable('https://survey-api-stage.vouchedfor.co.uk') + '/submission',
    roma_url: createReplaceVariable('https://roma-stage.vouchedfor.co.uk'),
    vf_2023_widget_launch_date: createReplaceVariable('2023-03-08'),
    microsoft_clarity: createReplaceVariable('h4ddncp13z'),
    gtag_key: createReplaceVariable('G-6CZRXSKQR3'),
    mixpanel_project_token: createReplaceVariable('f9ecf18cffd054cd97b31c222451b952'),
    end_of_2025_guide: createReplaceVariable('REACT_APP_END_OF_2025_GUIDE'),
};

export const INTEGRATION_KEYS = {
    sentry_dsn: createReplaceVariable('https://164d8d6e037f4f44ad49879d2daf1823@o89905.ingest.sentry.io/4504914947670016'),
    sentry_env: createReplaceVariable('stage')
}

export default API_KEYS;
